export default function customerCodeReducer(state = {}) {
  return state;
}
